@if (isLoading) {
  <app-content-loader></app-content-loader>
}
@if (isInitialized) {
  <div class="step-container columns is-desktop" [class.d-none]="isLoading">
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [workFlowController]="workFlowController"
    ></app-aside-bar>
    <div class="package-selection">
      @if (statement.isStandardPackageAvailable) {
        <h1 class="title package_title">
          {{ "PACKAGE_SELECTION.TITLE" | translate }}
        </h1>
        <p class="package_desc">
          {{ "PACKAGE_SELECTION.DESCRIPTION" | translate }}
        </p>
      }
      @if (!statement.isStandardPackageAvailable && statement.isPremiumPackageAvailable) {
        <h1 class="title package_title">
          {{ "PACKAGE_SELECTION.TITLE_ONE_PACKAGE" | translate }}
        </h1>
        <p class="package_desc">
          {{ "PACKAGE_SELECTION.DESCRIPTION_ONE_PACKAGE" | translate }}
        </p>
      }
      @if (!statement.isStandardPackageAvailable && !statement.isPremiumPackageAvailable) {
        <h1 class="title package_title">
          {{ "PACKAGE_SELECTION.TITLE_NO_PACKAGE" | translate }}
        </h1>
        <p class="package_desc">
          {{ "PACKAGE_SELECTION.DESCRIPTION_NO_PACKAGE" | translate }}
        </p>
      }
      <div class="package_choise_sec">
        <div class="top_select_btns_cont hidden_lg">
          <div class="top_select_btns_wrap swiper-wrapper">
            <!-- @if (statement.isStandardPackageAvailable) { -->
            <div
              class="single_btn owl-slide"
              (click)="changeSlide(0)"
              [class.active_slide]="currentSlide == 0"
              [class.active_tab]="statement.isStandardPackage"
              [class.disactive]="!statement.isStandardPackageAvailable"
            >
              <span>{{ "PACKAGE_SELECTION2.PREMIUM.TAX_OPTION_PREMIUM_LOW" | translate }}</span>
            </div>
            <!-- } -->
            <!-- @if (statement.isPremiumPackageAvailable) { -->
            <div
              class="single_btn owl-slide"
              (click)="changeSlide(1)"
              [class.active_slide]="currentSlide == 1"
              [class.active_tab]="statement.isPremiumPackage"
            >
              <span>{{ "PACKAGE_SELECTION2.STEUER.TAX_OPTION_STEUER_LOW" | translate }}</span>
            </div>
            <!-- } -->
          </div>
        </div>
        @if (onlyPremiumInfoActive) {
          <span class="only-premium">{{ "PACKAGE_SELECTION2.ONLY_PREMIUM_INFO" | translate }}</span>
        }
        <div class="package_choise_cont">
          <div class="package_choise options active">
            <ul class="package_choise_list">
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_2" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_4" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_8" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_6" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_7" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_5" | translate }}</span>
              </li>
              <li>
                <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_9" | translate }}</span>
              </li>
            </ul>
          </div>
          <div class="package_choise_slider">
            <owl-carousel-o #owlCar [options]="customOptions" (translated)="getPassedData($event)">
              <ng-template carouselSlide id="slide_0">
                <div class="package_choise_slider_header">
                  <span>{{ "PACKAGE_SELECTION2.HOW_DOES_IT_WORK" | translate }}</span>
                  <span>
                    <app-more-info-tooltip
                      [showText]="false"
                      [titleTooltip]="'PACKAGE_SELECTION2.HOW_DOES_IT_WORK'"
                      [contentTemplateRef]="standardPackageTooltipTemplate1"
                    ></app-more-info-tooltip>
                    <ng-template #standardPackageTooltipTemplate1>
                      <app-tooltip-template-package-info
                        [isStandardPackage]="true"
                        [isHowDoesItWork]="true"
                        [standardAmount]="dataSelect.packageOptions.defaultStandardAmount"
                        [premiumAmount]="dataSelect.packageOptions.defaultPremiumAmount"
                        [currencySymbol]="dataSelect.packageOptions.currencySymbol.symbol"
                      >
                      </app-tooltip-template-package-info>
                    </ng-template>
                  </span>
                </div>
                <div
                  [attr.data-cy]="'packageOptionPaid'"
                  class="package_choise order-1-mobile center_row owl-slide"
                  [class.selected]="statement.isStandardPackage"
                  [class.active_tab]="activeStandardTab"
                  [class.no_free]="statement.hasAbroadIncome"
                  [class.active]="statement.isStandardPackageAvailable"
                >
                  <div class="package_choise_content" (click)="selectPackageClick(packageOption.paid)">
                    <div class="package_choise_wrap premium" [class.no_free]="statement.hasAbroadIncome">
                      <div class="top_title">
                        <span>{{ "PACKAGE_SELECTION2.PREMIUM.TAX_OPTION_PREMIUM" | translate }}</span>
                      </div>
                      <div class="select_package">
                        <div class="select_package_desc">
                          {{ "PACKAGE_SELECTION2.STANDARD_PACKAGE_SUBTITLE" | translate }}
                        </div>
                      </div>
                      <div class="package_choise_list_price">
                        <div class="package_choise_list_price_desc">
                          <div class="price">
                            <span class="cur">{{ dataSelect.packageOptions.currencySymbol.symbol }}</span>
                            <span class="lg_price">{{
                              numberFormatHelper.integer(statementPaymentAmount.standardAmountTotal)
                            }}</span>
                            <span class="sm_price">
                              {{ numberFormatHelper.decimal(statementPaymentAmount.standardAmountTotal) }}
                              <div class="tooltip_package_free">
                                <app-more-info-tooltip
                                  [titleTooltip]="'PACKAGE_SELECTION2.STANDARD.PRICING_DETAILS_FREE.TITLE'"
                                  [message]="'PACKAGE_SELECTION2.STANDARD.PRICING_DETAILS_FREE.DESCRIPTION'"
                                ></app-more-info-tooltip>
                              </div>
                            </span>
                          </div>
                          <div class="text-muted text-center">
                            {{ "PACKAGE_SELECTION2.PREMIUM.FOR_EVERY_STATEMENT" | translate }}
                          </div>
                        </div>
                        <div class="package_choise_btn">
                          <div class="icon"><img src="../../../assets/svg/shield_negative.svg" /></div>
                          {{ "PACKAGE_SELECTION2.NO_SUPPORT" | translate }}
                        </div>
                      </div>

                      <ul class="package_choise_list">
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_2" | translate }}</span>
                          <img src="../../../assets/svg/thick_v2.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_4" | translate }}</span>
                          <img src="../../../assets/svg/thick_v2.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_5" | translate }}</span>
                          <img class="no" src="../../../assets/svg/false.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_6" | translate }}</span>
                          <img class="no" src="../../../assets/svg/false.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_7" | translate }}</span>
                          <img class="no" src="../../../assets/svg/false.svg" />
                        </li>
                        <li>
                          <div class="btn_list_green visible_sm">
                            <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_8" | translate }}</span>
                          </div>
                          <img class="no" src="../../../assets/svg/false.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_9" | translate }}</span>
                          <img class="no" src="../../../assets/svg/false.svg" />
                        </li>
                      </ul>
                      <div class="checkbox-section" [class.active]="statement.isStandardPackage">
                        <div class="fake-checkbox">
                          @if (statement.isStandardPackage) {
                            <img class="no" src="../../../assets/svg/true_black.svg" />
                          }
                        </div>
                        <span class="checkbox_label">
                          {{ "PACKAGE_SELECTION2.CHOOSE_PACKAGE_CHECKBOX_TEXT" | translate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide id="slide_1">
                <div class="package_choise_slider_header">
                  <span>{{ "PACKAGE_SELECTION2.HOW_DOES_IT_WORK" | translate }}</span>
                  <app-more-info-tooltip
                    [showText]="false"
                    [titleTooltip]="'PACKAGE_SELECTION2.HOW_DOES_IT_WORK'"
                    [contentTemplateRef]="premiumPackageTooltipTemplate1"
                  ></app-more-info-tooltip>
                  <ng-template #premiumPackageTooltipTemplate1>
                    <app-tooltip-template-package-info
                      [isPremiumPackage]="!statementPaymentAmount.isPercentagePayment"
                      [isPremiumPlusPackage]="statementPaymentAmount.isPercentagePayment"
                      [isHowDoesItWork]="true"
                      [standardAmount]="dataSelect.packageOptions.defaultStandardAmount"
                      [premiumAmount]="dataSelect.packageOptions.defaultPremiumAmount"
                      [currencySymbol]="dataSelect.packageOptions.currencySymbol.symbol"
                    >
                    </app-tooltip-template-package-info>
                  </ng-template>
                </div>
                <div
                  [attr.data-cy]="'packageOptionPremium'"
                  class="package_choise order-0-mobile steuer owl-slide"
                  [class.selected]="statement.isPremiumPackage"
                  [class.active_tab]="activeSteuerTab"
                  [class.active]="statement.isPremiumPackageAvailable"
                  [class.no_free]="statement.hasAbroadIncome"
                >
                  <div class="package_choise_content" (click)="selectPackageClick(packageOption.tax_adviser)">
                    <div class="package_choise_wrap steuer">
                      <div class="top_title">
                        @if (!statementPaymentAmount.isPercentagePayment) {
                          <span>{{ "PACKAGE_SELECTION2.STEUER.TAX_OPTION_PREMIUM" | translate }}</span>
                        }
                        @if (statementPaymentAmount.isPercentagePayment) {
                          <span>{{ "PACKAGE_SELECTION2.STEUER.TAX_OPTION_PREMIUMPLUS" | translate }}</span>
                        }
                      </div>
                      <div class="select_package">
                        <div class="select_package_desc premium">
                          {{ "PACKAGE_SELECTION2.PREMIUM_PACKAGE_SUBTITLE" | translate }}
                        </div>
                      </div>
                      <div class="package_choise_list_price">
                        <div class="package_choise_list_price_desc steuer">
                          @if (statementPaymentAmount.shouldBeIndividualService) {
                            <div class="font-weight-bolder text-center px-0_5">
                              {{ "PACKAGE_SELECTION2.SHOULD_BE_INDIVIDUAL_SERVICE" | translate }}
                              <app-more-info-tooltip
                                class="v-align-mid"
                                [message]="'PACKAGE_SELECTION2.SHOULD_BE_INDIVIDUAL_SERVICE_TOOLTIP'"
                                [isSmallIcon]="true"
                              ></app-more-info-tooltip>
                            </div>
                          }
                          @if (!statementPaymentAmount.shouldBeIndividualService) {
                            @if (statementPaymentAmount.isPercentagePayment) {
                              <div class="price">
                                <span class="lg_price">19</span>
                                <span class="cur">%</span>
                                <span class="percentage-text">{{
                                  "PACKAGE_SELECTION2.PREMIUM.TAX_RETURN" | translate
                                }}</span>
                              </div>
                              <div class="text-muted text-center premium">
                                {{ "PACKAGE_SELECTION2.PREMIUM.MINIMUM" | translate }}
                                {{
                                  numberFormatHelper.toFixed2(statementPaymentAmount.premiumAmountTotal) +
                                    " " +
                                    statementPaymentAmount.currencySymbol
                                }}
                              </div>
                            } @else {
                              <div class="price">
                                <span class="cur">{{ statementPaymentAmount.currencySymbol }}</span>
                                <span class="lg_price">{{
                                  numberFormatHelper.integer(statementPaymentAmount.premiumAmountTotal)
                                }}</span>
                                <span class="sm_price">{{
                                  numberFormatHelper.decimal(statementPaymentAmount.premiumAmountTotal)
                                }}</span>
                              </div>
                              <div class="text-muted text-center premium">
                                {{ "PACKAGE_SELECTION2.STEUER.FOR_EVERY_STATEMENT" | translate }}
                              </div>
                            }
                          }
                        </div>
                        <div class="package_choise_btn">
                          <div class="icon"><img src="../../../assets/svg/shield.svg" /></div>
                          @if (statementPaymentAmount.isPercentagePayment) {
                            {{ "PACKAGE_SELECTION2.STEUER.PAY_AFTERREFUND" | translate }}
                          }
                          @if (!statementPaymentAmount.isPercentagePayment) {
                            {{ "PACKAGE_SELECTION2.STEUER.PAY_LATER" | translate }}
                          }
                        </div>
                      </div>
                      <ul class="package_choise_list">
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_2" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_4" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_5" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_6" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_7" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <div class="btn_list_green visible_sm">
                            <span>{{ "PACKAGE_SELECTION2.LIST.OPTION_8" | translate }}</span>
                          </div>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                        <li>
                          <span class="visible_sm">{{ "PACKAGE_SELECTION2.LIST.OPTION_9" | translate }}</span>
                          <img src="../../../assets/svg/thick_black.svg" />
                        </li>
                      </ul>
                      <div class="checkbox-section" [class.active]="statement.isPremiumPackage">
                        <div class="fake-checkbox">
                          @if (statement.isPremiumPackage) {
                            <img class="no" src="../../../assets/svg/true_black.svg" />
                          }
                        </div>
                        <span class="checkbox_label">
                          {{ "PACKAGE_SELECTION2.CHOOSE_PACKAGE_CHECKBOX_TEXT" | translate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
        </div>
      </div>
      <div class="collapse-section">
        <app-collapse-component
          [text]="
            statementPaymentAmount.isPercentagePayment
              ? 'PACKAGE_SELECTION_COLLAPSE_INFO.PREMIUM_PLUS.TEXT'
              : 'PACKAGE_SELECTION_COLLAPSE_INFO.PREMIUM.TEXT'
          "
          [collapseText]="
            statementPaymentAmount.isPercentagePayment
              ? 'PACKAGE_SELECTION_COLLAPSE_INFO.PREMIUM_PLUS.COLLAPSE_TEXT'
              : 'PACKAGE_SELECTION_COLLAPSE_INFO.PREMIUM.COLLAPSE_TEXT'
          "
        ></app-collapse-component>
      </div>
    </div>
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
